import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/testimonials';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="px-4 py-8" data-id="element-34" data-mp="1hd1nhy7fx7zi">
      <div className="mx-auto max-w-3xl" data-id="element-35" data-mp="1hecojq9i41mx">
        <h2 className="text-center text-xl font-extrabold sm:text-3xl" data-id="element-36" data-mp="1cei1jxsujw75">
          Frequently Asked Questions
        </h2>
        <div className="mt-4 space-y-2" data-id="element-37" data-mp="2a2s3kcsmujy9">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-ink-line bg-ink-panel" data-id="element-38" data-mp="254gsjyqlq3eg" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left" data-id="element-39" data-mp="2027yez1zsvar">
                  <span className="font-display text-[13px] font-bold uppercase leading-tight text-white sm:text-base" data-id="element-40" data-mp="oqgwwzysgzx0">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-gold transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-41" data-mp="1koru5nlwc6ko" />
                </button>
                {isOpen && <p className="border-t border-ink-line px-4 py-3 text-xs leading-snug text-ink-text sm:text-sm" data-id="element-42" data-mp="1aq2bvtq38k3w">
                    {faq.answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}